<template>
  <v-layout row justify-center align-start v-resize="getDimensions">
    <v-flex>
      <v-app-bar flat color="white">
        <v-toolbar-title class="font-weight-black primary--text"
          >Subcategoría</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="mostrarCarga"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> file_upload </v-icon>
            </v-btn>
          </template>
          <span>Carga masiva de datos</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nuevo registro</span>
        </v-tooltip>
      </v-app-bar>
      <v-sheet class="overflow-y-auto" :max-height="height">
        <v-data-table
          dense
          fixed-header
          :height="height - (isMobile ? 128 : 200)"
          :headers="headers"
          :items="subcategorias"
          :items-per-page="50"
          :search="search"
          sort-by="codigo"
          class="elevation-1"
          group-by="categoria"
          :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': 'Filas por página',
            'items-per-page-options': [-1, 50, 100, 150],
          }"
        >
          <template
            v-slot:group.header="{ group, headers, toggle, isOpen, items }"
          >
            <th :colspan="headers.length">
              <v-toolbar dense color="white" lights-out class="elevation-0">
                <v-btn @click="toggle" x-small icon :ref="group">
                  <v-icon v-if="isOpen">fa-solid fa-chevron-up</v-icon>
                  <v-icon v-else>fa-solid fa-chevron-down</v-icon>
                </v-btn>
                <v-btn x-small icon>
                  <v-icon></v-icon>
                </v-btn>
                <v-list-item-avatar
                  @click="toggle"
                  :ref="group"
                  color="primary"
                  class="text-h5 font-weight-light white--text"
                >
                  {{ group.charAt(0) }}
                </v-list-item-avatar>

                <span class="mx-5 font-weight-bold primary--text">{{
                  "CATEGORÍA: " + group
                }}</span>
                <v-spacer></v-spacer>
              </v-toolbar>

              <div></div>
            </th>
          </template>
          <template v-slot:[`item.opciones`]="{ item }">
            <v-btn x-small text dark color="primary" @click="editItem(item)">
              <v-icon x-small>edit</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.estado`]="{ item }">
            <div v-if="item.estado == 'A'">
              <v-btn
                color="success"
                x-small
                text
                dark
                @click="desactivar(item)"
              >
                <v-icon x-small>check</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <v-btn color="error" x-small text dark @click="activar(item)">
                <v-icon x-small>block</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="font-weight-black primary--text">
              </v-toolbar-title>
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda General"
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchCodigoValue"
                append-icon="search"
                label="Búsqueda por código"
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchDescripcionValue"
                append-icon="search"
                label="Búsqueda por descripción"
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>

              <v-dialog
                v-model="dialog"
                max-width="500px"
              >
                <v-card ref="form">
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <span class="font-weight-black primary--text"
                      >{{ formTitle }}
                    </span>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="guardar"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> fa-solid fa-floppy-disk </v-icon>
                        </v-btn>
                      </template>
                      <span>Guardar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="close"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> fa-solid fa-xmark </v-icon>
                        </v-btn>
                      </template>
                      <span>Volver</span>
                    </v-tooltip>
                  </v-app-bar>

                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          outlined
                          dense
                          ref="codigo"
                          v-model="codigo"
                          :readonly="!editCodigo"
                          :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                          :error-messages="errorMessages"
                          label="Código"
                          placeholder="Código"
                          required
                        ></v-text-field>

                        <v-text-field
                          outlined
                          dense
                          ref="descripcion"
                          v-model="descripcion"
                          :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                          :error-messages="errorMessages"
                          label="Descripción"
                          placeholder="Descripción"
                          required
                        ></v-text-field>

                        <v-autocomplete
                          outlined
                          dense
                          ref="id_categoria"
                          v-model="id_categoria"
                          :items="categorias"
                          :rules="[$rules.requerido]"
                          :error-messages="errorMessages"
                          @change="tipo = 'O'"
                          item-text="descripcion"
                          item-value="id"
                          label="Categoría"
                          required
                        ></v-autocomplete>

                        <v-autocomplete
                          outlined
                          dense
                          ref="id_cuenta_contable"
                          v-model="id_cuenta_contable"
                          :items="cuentasContables"
                          :rules="[$rules.requerido]"
                          :error-messages="errorMessages"
                          item-text="descripcion"
                          item-value="id"
                          label="Cuenta Contable"
                          required
                        ></v-autocomplete>

                        <v-autocomplete
                          outlined
                          dense
                          ref="tipo"
                          v-model="tipo"
                          :items="tipos"
                          :rules="[$rules.requerido]"
                          :error-messages="errorMessages"
                          item-text="descripcion"
                          item-value="id"
                          label="Tipo"
                          required
                        ></v-autocomplete>

                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="listar">Reset</v-btn>
          </template>
        </v-data-table>
      </v-sheet>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      width: 0,
      height: 0,
      isMobile: false,
      subcategorias: [],
      cuentasContables: [],
      categorias: [],
      tipos: [
        { id: "I", descripcion: "INGRESO" },
        { id: "D", descripcion: "DESCUENTO" },
        { id: "O", descripcion: "OTRO" },
      ],
      auxWidth: 0,
      auxHeigth: 0,
      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight + this.auxHeigth,
      tipo_presupuesto:"NOM",
      dialog: false,
      dialogUpload: false,
      usuario: this.$store.state.usuario.user,
      rol: this.$store.state.usuario.rol,
      page: 1,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "5%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cuenta Contable",
          value: "cuenta_contable",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Categoría",
          value: "categoria",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Tipo",
          value: "tipo",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],
      search: "",
      searchCodigoValue: "",
      searchDescripcionValue: "",
      editedIndex: -1,
      editCodigo: false,
      mostrarErrores: false,

      id: "",
      codigo: "",
      descripcion: "",
      id_cuenta_contable: "",
      id_categoria: "",
      tipo: "",
      
      file: null,
      valida: 0,
      validaMensaje: [],
      adCodigo: "",
      errorMessages: "",
      error: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        id_cuenta_contable: this.id_cuenta_contable,
        id_categoria: this.id_categoria,
        tipo: this.tipo,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    name() {
      this.errorMessages = "";
    },
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    this.listar();
    this.selectCuentasContables();
    this.selectCategorias();
  },

  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/subcategorias/cargarExcel" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo seleccionado, verifique los errores.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/subcategorias/listar/" + me.usuario)
        .then(function (response) {
          me.subcategorias = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectCuentasContables() {
      let me = this;
      axios
        .get(
          "api/cuenta_contables/SelectTipoPresupuesto/" + me.tipo_presupuesto + "/"+ me.usuario
        )
        .then(function (response) {
          me.cuentasContables = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    selectCategorias() {
      let me = this;
      axios
        .get("api/categorias/select")
        .then(function (response) {
          me.categorias = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },

    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.id_cuenta_contable = item.id_cuenta_contable;
      this.id_categoria = item.id_categoria;
      this.tipo = item.tipo;
      
      this.editedIndex = 1;
      this.editCodigo = false;
      this.dialog = true;
    },

    addItem() {
      this.editCodigo = true;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.id_cuenta_contable = "";
      this.id_categoria = "";
      this.tipo = "";
      this.validaMensaje = [];
      this.editedIndex = -1;
    },

    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      let me = this;
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndex > -1) {
        axios
          .put("api/subcategorias/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_cuenta_contable: me.id_cuenta_contable,
            id_categoria: me.id_categoria,
            tipo: me.tipo,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        axios
          .post("api/subcategorias/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_cuenta_contable: me.id_cuenta_contable,
            id_categoria: me.id_categoria,
            tipo: me.tipo,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;
      Object.keys(this.form).forEach((f) => {
        if(this.$refs[f]) {
          this.$refs[f].validate(true);
          if (this.$refs[f].validate(true)) {
            this.valida += 0;
          } else {
            this.valida += 1;
          }
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/subcategorias/activar/" + item.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/subcategorias/desactivar/" + item.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error,
            color: "error",
          });
        });
    },

    filtroCodigo(value) {
      if (!this.searchCodigoValue) {
        return true;
      }
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },
    
    filtroDescripcion(value) {
      if (!this.searchDescripcionValue) {
        return true;
      }
      return value
        .toLowerCase()
        .includes(this.searchDescripcionValue.toLowerCase());
    },
  },
};
</script>
